module.exports = __webpack_public_path__ + "static/media/history-active.390dc3f8.svg";